<template>
  <div>
    <footer class="footer">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 footer-copyright text-left">
            <span class="mb-0">{{$t("lbl_EMPBE_Footer_Tips",{currentYear:year})}}</span>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
  import json from '../data/menu';
  
  export default {
    name: 'footerpage',
    data() {
      return {
        customizer: false,
        year:new Date().getFullYear(),
        data:
          'data:text/json;charset=utf-8,' +
          encodeURIComponent(JSON.stringify(json)),
      };
    },
  };
</script>
